import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Pagination,Row,Col,Modal} from 'react-bootstrap';
import OverlayLoader from 'react-overlay-loading/lib/OverlayLoader';
import {Link} from 'react-router-dom';
import {viewFlatFile,getAllFilesByReportTypes} from '../../Utilities/WSUtil';
import {API_BASE_URL} from '../../resources/constant';

import {SubmitBtn,MidCifBtn} from '../../theme/MorsTheme';

import {ContentDiv, BodyHeaderDiv, BodyHeaderText} from '../../theme/MorsTheme';

const propTypes = {
    items: PropTypes.array.isRequired,
    onChangePage: PropTypes.func.isRequired,
    initialPage: PropTypes.number,
    pageSize: PropTypes.number
}

const defaultProps = {
    initialPage: 1,    
    pageSize: 20
}

class ReportDateList extends Component{            
    constructor(props){
        super(props);                  
        this.state = {
            url:API_BASE_URL+'cad/merchant/getMerchCreditNotice?',
            pager: {},
            pageOfItems: [],
            totalPage:'',
            loading: false

        };  
        this.viewReport = this.viewReport.bind(this);
        this.onChangePage = this.onChangePage.bind(this);        
        this.getReportList = this.getReportList.bind(this);  
        this.insertSlash = this.insertSlash.bind(this);
    }

    viewReport(merchantId){
        // alert(merchantId +" "+this.props.UploadDate);
        this.props.getCreditReports(merchantId,this.props.UploadDate)
    }

    goBack = e => {
        e.preventDefault();
        this.props.history.goBack();
    }
    onChangePage(pageOfItems){        
        this.setState({pageOfItems: pageOfItems});
    }

    componentWillMount(){        

        if(this.props.items && this.props.items.length){            
            this.setPage(this.props.initialPage);
        }
        
    }
    componentDidMount(){        
        this.props.items.map((item, index) => 
            this.props.SingleId === item.merchant?this.setState({totalPage: 1}):''
        )
        
        
    }
    componentDidUpdate(prevProps, prevState){     
        if(this.props.items !== prevProps.items){         
            this.setPage(this.props.initialPage);
        }
    }
    setPage(page){
        var {items, pageSize} = this.props;
        var pager = this.state.pager;
        if(page<1 || page > pager.totalPages){
            return;
        }        
        pager = this.getPager(items.length, page, pageSize);
        var pageOfItems = items.slice(pager.startIndex, pager.endIndex + 1);
        this.setState({pager: pager});        
        this.onChangePage(pageOfItems); 
        
        var totalP= Math.ceil(this.props.items.length/pageSize)
        this.setState({totalPage: totalP});
    }

    getPager(totalItems, currentPage, pageSize){                               
        currentPage = currentPage || 1;
        pageSize = pageSize || 20;        
        var totalPages = Math.ceil(totalItems/pageSize);        
        var startPage, endPage;        
        if(totalPages <=10){
            startPage = 1;
            endPage = totalPages;
        }
        
        else{
            if(currentPage <=4){
                startPage = 1;
                endPage = 20;
            }else if(currentPage + 4 >= totalPages){
                startPage = totalPages - 4;
                endPage = totalPages;
            }else{
                startPage = currentPage - 20;
                endPage = currentPage + 4;                
            }
        }

        var startIndex = (currentPage - 1 ) * pageSize;
        var endIndex = Math.min(startIndex + pageSize -1, totalItems -1);
        var pages = [...Array((endPage +1) - startPage).keys()].map(i=> startPage +i);

        return {
            totalItems: totalItems,
            currentPage: currentPage,
            pageSize: pageSize,
            totalPages: totalPages,
            startPage: startPage,
            endPage: endPage,
            startIndex: startIndex,
            endIndex: endIndex,
            pages:pages
        };    
    }

    getReportList(dateClicked){
        
        var data = JSON.parse(this.props.reportData);
        var date = this.insertSlash(dateClicked);
        this.setState({loading: true});
        getAllFilesByReportTypes(                      
            data.userId,
            data.groupId,
            data.menuId,          
            data.subMenuId,
            date,
            date,            
            data.reportType,            
            data.searchSingleId,            
            data.checkedAllReport
        ).then(response => {
            // console.log("RESP: "+response)                
            this.props.getReports(response);            
            this.setState({loading: false});
            //this.props.history.push("/reportsFileList");
        }).catch(error =>{            
            alert("getReportList "+ JSON.stringify(error));
        })
    }

    insertSlash(val) {
        return val.replace(/^(\d{2})(\d{2})/, '$1/$2/');
    }
                     
    render(){        
        var pager = this.state.pager;
        return(
            <div >                            
                <BodyHeaderDiv>
                    <BodyHeaderText>List of Reports</BodyHeaderText>
                </BodyHeaderDiv>
                <ContentDiv >
                    <div align="center">            
                    <Row as={Row} noGutters style={this.props.items.length !== 0 ? {display:'block'}: {display:'none'}}>    
                    <Row noGutters>
                            <Col md={20}>The following is/are the only Dates that have reports:</Col>
                    </Row>
                        {this.props.items.map((item, index) =>                                                             
                            <Row key={index} style={{fontSize:'12px'}}>   
                                <Col md={12}>                                
                                <a onClick={() =>this.getReportList(item)}> <span style={{fontSize:'12px'}}>{item}</span></a>
                                </Col>
                            </Row>
                            )}                                            
                    </Row>
                    </div>
                    <div align="center" style={this.props.items.length !== 0 ? {display:'block', marginTop: '20px'}: {display:'none'}}>                            
                        <Pagination style={{display: 'flex', justifyContent:'center'}}>
                            <Pagination.First onClick={() => this.setPage(1)} />                                                                        
                            <Pagination.Prev onClick={() => this.setPage(pager.currentPage - 1)}/>                                                                        
                            <Pagination.Next onClick={() => this.setPage(pager.currentPage + 1)}/>
                            <Pagination.Last onClick ={() => this.setPage(pager.totalPages)}/>                     
                        </Pagination>                                             
                        
                        <div align="center">
                            <span>Page {pager.currentPage}</span> / {" "}                            
                            <span>{this.state.totalPage}</span>
                        </div>  
                    </div>
                    
                                
                    <Row>
                        <Col>
                        <div style={this.props.items.length === 0 ? {display:'block'}: {display:'none'}}>
                            <span style={{color:'red'}}>Sorry, there is/are no recorded transaction/s for the date you selected.</span>                                                                                   
                        </div>
                        </Col>
                    </Row>
                    <Row style={{ marginTop:'20px'}}>
                        <Col>
                        <SubmitBtn style={{color:'#FFFFFF'}} onClick= {this.goBack}>Back</SubmitBtn>
                        </Col>

                    </Row>
                
            </ContentDiv>

            <Modal show={this.state.loading} backdrop={'static'}  centered={true} backdropClassName='fade' dialogClassName="modal-bdox">  
                    <div>
                        <OverlayLoader
                            color={'#0B2972'}
                            loader="ClipLoader"
                            text="Loading..."
                            active={true}
                            backGroundColor={'black'}
                            opacity=".9">
                        </OverlayLoader>                
                    </div>                                  
                </Modal>   
        </div>                                  
    )
        
    }
    
}

ReportDateList.propTypes = propTypes;
ReportDateList.defaultProps = defaultProps;
export default ReportDateList;
